"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMedia = require("react-media");

var _reactMedia2 = _interopRequireDefault(_reactMedia);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SystemMessage = function (_React$Component) {
  _inherits(SystemMessage, _React$Component);

  function SystemMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SystemMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SystemMessage.__proto__ || Object.getPrototypeOf(SystemMessage)).call.apply(_ref, [this].concat(args))), _this), _this.showIcon = false, _this.handleResize = function () {
      if (_this.bannerSpacer) {
        if (!_this.bannerLabel) {
          _this.bannerSpacer.classList.add("cdk-banner--show-icon");
        } else if (_this.bannerLabel.textContent.length >= 60 && _this.bannerLabel.textContent.length <= 180) {
          _this.bannerSpacer.classList.add("cdk-banner--mobile-spacer");
        }
      }

      if (_this.systemMessageDiv && _this.bannerSpacer) {
        var width = _this.systemMessageDiv.offsetWidth;

        if (width >= 720) {
          _this.bannerSpacer.classList.add("cdk-system-message__content--center-aligned");
        } else {
          if (_this.bannerSpacer.classList.contains("cdk-system-message__content--center-aligned")) {
            _this.bannerSpacer.classList.remove("cdk-system-message__content--center-aligned");
          }
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SystemMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          warning = _props.warning,
          success = _props.success,
          critical = _props.critical,
          informational = _props.informational,
          other = _objectWithoutProperties(_props, ["className", "children", "warning", "success", "critical", "informational"]);

      return _react2.default.createElement("div", _extends({
        className: (0, _classnames2.default)("cdk-system-message", {
          "cdk-system-message--warning": warning
        }, {
          "cdk-system-message--success": success
        }, {
          "cdk-system-message--critical": critical
        }, {
          "cdk-system-message--informational": informational
        }, className),
        ref: function ref(_ref2) {
          _this2.systemMessageDiv = _ref2;
        }
      }, other), _react2.default.createElement("div", {
        ref: function ref(bannerSpacer) {
          _this2.bannerSpacer = bannerSpacer;
        },
        className: (0, _classnames2.default)("cdk-system-message__content", className)
      }, _react2.default.createElement("i", {
        ref: function ref(bannerIcon) {
          _this2.bannerIcon = bannerIcon;
        },
        className: (0, _classnames2.default)({
          "cdkicon-flag": !warning && !success && !critical && !informational
        }, {
          "cdkicon-warning": warning
        }, {
          "cdkicon-thumb_up": success
        }, {
          "cdkicon-error": critical
        }, {
          "cdkicon-info": informational
        }, className)
      }), _react2.default.createElement(_reactMedia2.default, {
        query: "(max-width:480px) and (orientation: portrait), (max-width:959px) and (orientation: landscape)"
      }, function (matches) {
        return matches ? _react2.default.createElement("div", {
          ref: function ref(bannerLabel) {
            _this2.bannerLabel = bannerLabel;
          },
          className: (0, _classnames2.default)("cdk-banner__text", {
            "cdk-banner-label": _this2.showIcon
          })
        }, children) : _react2.default.createElement("div", {
          className: (0, _classnames2.default)("cdk-banner__text", className)
        }, children);
      })));
    }
  }]);

  return SystemMessage;
}(_react2.default.Component);

SystemMessage.propTypes = {
  warning: _propTypes.bool,
  success: _propTypes.bool,
  critical: _propTypes.bool,
  informational: _propTypes.bool,
  showIcon: _propTypes.bool
};
exports.default = SystemMessage;